// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e508514b","455":"3ec4fa9f","977":"fa0c6a46"}[chunkId] + ".chunk.js";
};